
import { jwtDecode } from 'jwt-decode';
export const decodeToken = () => {
  const token = sessionStorage.getItem('token') || localStorage.getItem('token');
  
  if (!token) {
    console.error('No token found');
    return null;
  }

  try {
    return jwtDecode(token);
  } catch (error) {
    console.error('Invalid token:', error);
    return null;
  }
};
